<template>
  <div
    class="app-main-content"
    style="position:relative;"
  >
    <ai-detail-workspace
      ref="bookingWorkspace"
      :parent-context="context"
      :open-multiple="true"
      @back="backToList"
    />
  </div>
</template>

<script>
import { AiBookingContext } from '@/views/cargo/v0/AirImport/aiBookingContext'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { advancedQuery } from '@/api/AirImport/aiBooking'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { cache } from '@/utils/cacheManager'
import lodash from 'lodash'
import aiDetailWorkspace from './aiWorkspace'

export default {
  name: 'DestinationBusinessAiDetail',
  components: { aiDetailWorkspace },
  data() {
    return {
      context: new AiBookingContext(),
      loading: null
    }
  },
  computed: {
    officeId() {
      return this.$store.getters.currentOfficeId
    }
  },
  async created() {
    await this.context.prepareData()
    // 加载UICustom配置，确保与源业务类型详情页配置一致
    if (Number(cache.hqConfig.get('UICustomization')) === 1) {
      const branchId = this.$store.getters.currentOfficeId
      await UICustomUtil.loadUICustomPageInfo('/DestinationBusiness/AiDetail', branchId)
    }
  },
  async mounted() {
    const jobNo = this.$route.query.key
    const branchId = this.$route.params.branchId || this.$store.getters.currentOfficeId
    if (!jobNo) {
      this.$message.error(this.$t('Message.JumpFailed'))
      return
    }
    const loading = getLoading4Cxt(this)
    try {
      const params = { branchId, jobNo, pageNum: 1 }
      const res = await advancedQuery(params)
      let rowData = res.data.list || []
      if (rowData.length === 0) {
        this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
        return
      }
      rowData = lodash.cloneDeep(rowData)
      for (const item of rowData) {
        new AirImportJob(item).fillDefaultValue()
        item.version = 0
      }
      // 从store获取列表页当前页数据，用于左侧业务编号列表展示
      const storeJobs = this.$store.state.destinationBusiness.currentPageJobs || []
      if (storeJobs.length > 0) {
        // 过滤出AI类型的业务数据
        const aiJobs = storeJobs.filter(job => job.lob === 'AI')
        if (aiJobs.length > 0) {
          const mergedData = []
          const apiJobMap = new Map(rowData.map(j => [j.jobNo, j]))
          for (const job of aiJobs) {
            const apiJob = apiJobMap.get(job.jobNo)
            mergedData.push(apiJob || job)
          }
          rowData = lodash.cloneDeep(mergedData)
          for (const item of rowData) {
            new AirImportJob(item).fillDefaultValue()
            item.version = 0
          }
        }
      }
      const selectedRow = rowData.find(p => p.jobNo === jobNo) || rowData[0]
      let action = 'look'
      if (this.$route.params.action) {
        action = this.$route.params.action
        delete this.$route.params.action
      }
      this.$refs.bookingWorkspace.onShow(action, rowData, selectedRow)
    } catch (err) {
      this.$message.error(this.$t('Message.JumpFailed'))
      throw err
    } finally {
      loading.close()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    backToList() {
      const targetPath = this.$route.query.menuType === 'overseaTracking'
        ? '/DestinationBusiness/OverseaTracking'
        : '/DestinationBusiness/EndCommerce'
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({ path: targetPath })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
